import React, { useEffect, useState } from 'react';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Swal from 'sweetalert2';
import { generateAxiosInstance } from '../../hooks/useAuthorizedRequest';
import { generateAxiosInstanceCommon } from '../../hooks/useAuthorizedReuestCommon';
import ViewImageAndText from '../../components/ViewImageAndText';
import { CModal } from '@coreui/react';
import { generateAxiosInstanceSection } from '../../hooks/useAuthorizedRequestForSection';
import { generateAxiosInstanceInstitute } from '../../hooks/useAuthorizedRequestForInstitute';
import { useNavigate } from 'react-router-dom';
import { competitiveExamCreateMultipleSubjectFormValidation, competitiveExamCreateSingleSubjectBlankQuestionFormValidation, competitiveExamCreateSingleSubjectFormValidation, competitiveExamExamAddQuestion, textBookExamAddQuestion, textBookExamCreateMultipleSubjectFormValidation, textBookExamCreateSingleSubjectBlankQuestionFormValidation, textBookExamCreateSingleSubjectFormValidation } from '../../validation/Validation';
import { handelError } from '../../validation/validationError';
import { ZodError } from "zod";
import { ErrorMessage } from '../../validation/validationError';
import { ImageModal, isErrorCreateExamQuestion, Loader, QuestionFilter, SolutionModal, validateCreateExamQuestionData } from '../../components/ModalsCommonFunctions';

const CreateExam = () => {
  let instituteMasterId = localStorage.getItem("instituteMasterId")
  let sectionMasterId = localStorage.getItem("sectionMasterId")
  const authorizedAxios = generateAxiosInstance()
  const authorizedAxiosCommon = generateAxiosInstanceCommon()
  const authorizedAxiosSection = generateAxiosInstanceSection()
  const authorizedAxiosInstitute = generateAxiosInstanceInstitute()
  const [loading, setLoading] = useState(false);
  const [examType, setExamType] = useState(true);
  const [isMulti, setIsMulti] = useState("N");
  const [showAddedTextBookQuestion, setShowAddedTextBookQuestion] = useState(false);
  const [addedTextBookQuestions, setAddedTextBookQuestions] = useState([]);

  const [isMultiCompetitive, setIsMultiCompetitive] = useState("N");
  const [showAddedCompetitiveQuestion, setShowAddedCompetitiveQuestion] = useState(false);
  const [addedCompetitiveQuestions, setAddedCompetitiveQuestions] = useState([]);

  const initialExamPatternState = {
    section_id: sectionMasterId,
    subjectName: "",
    lessonName: "",
    topicName: "",
    subtopicName: "",
    exam_name: "",
    description: "",
    syllabus_structure_id: '',
    syllabus_structure_type: '',
    class_id: '',
    subject_id: '',
    lesson_id: '',
    topic_id: '',
    subtopic_id: '',
    questions: []
  }

  const [examCreateData, setExamCreateData] = useState(initialExamPatternState)
  const [errorQuestions, setErrorQuestions] = useState({})
  const [classList, setClassList] = useState([])
  const [syllabusList, setSyllabusList] = useState([]);
  const [subjectList, setSubjectList] = useState([])
  const [lessonList, setLessonList] = useState([])
  const [topicList, setTopicList] = useState([])
  const [subtopicList, setSubtopicList] = useState([])
  const [questionList, setQuestionList] = useState([]);
  const [syType, setSyType] = useState()

  const [visible, setVisible] = useState(false)
  const [modalData, setModalData] = useState("")
  const [visibleImage, setVisibleImage] = useState(false);
  const [modalImageSrc, setModalImageSrc] = useState('');

  const [errors, setErrors] = useState([]);
  const navigate = useNavigate();

  // Competitive Exam State Variables Start
  const initialCompetitiveExamPatterState = {
    section_id: sectionMasterId,
    subjectName: "",
    lessonName: "",
    topicName: "",
    subtopicName: "",
    exam_name: "",
    description: "",
    competitive_exam_id: '',
    competitive_exam_type: '',
    class_id: '',
    book_id: '',
    subject_id: '',
    lesson_id: '',
    topic_id: '',
    subtopic_id: '',
    questions: []
  }

  const [examCreateDataCompetitiveExam, setExamCreateDataCompetitiveExam] = useState(initialCompetitiveExamPatterState)
  const [errorQuestionsCompetitiveExam, setErrorQuestionsCompetitiveExam] = useState({})
  const [lessonListCompetitiveExam, setLessonListCompetitiveExam] = useState([])
  const [competitiveExamNameList, setCompetitiveExamNameList] = useState([]);
  const [competitiveExamBookList, setCompetitiveExamBookList] = useState([])
  const [subjectListCompetitiveExam, setSubjectListCompetitiveExam] = useState([])
  const [topicListCompetitiveExam, setTopicListCompetitiveExam] = useState([])
  const [subtopicListCompetitiveExam, setSubtopicListCompetitiveExam] = useState([])
  const [questionListCompetitiveExam, setQuestionListCompetitiveExam] = useState("");
  const [syTypeCompetitiveExam, setSyTypeCompetitiveExam] = useState()
  const [errorsCompetitiveExam, setErrorsCompetitiveExam] = useState([]);

  const onViewImage = (imgSrc) => {
    setModalImageSrc(imgSrc);
    setVisibleImage(true);
  };

  const handleNavigate = (route) => {
    navigate(route);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "subtopic_id") {
      const selectedOption = e.target.options[e.target.selectedIndex];
      const selectedSubtopicName = selectedOption.getAttribute('data-subtopic-name');
      setExamCreateData((prevData) => {
        return {
          ...prevData,
          [name]: value,
          subtopicName: selectedSubtopicName
        }
      })
    } else {
      setExamCreateData((prevData) => {
        return {
          ...prevData,
          [name]: value
        }
      })
    }

    // Clear the error for the specific field being edited
    if (value.trim() !== '') {
      setErrors(prevErrors => prevErrors.filter(error => error.path[0] !== name));
    }
  }

  useEffect(() => {
    setExamCreateData((prevData) => {
      return {
        ...prevData,
        questions: []
      }
    })
    setAddedTextBookQuestions([]);
  }, [isMulti])

  const handleClassChange = (e) => {
    const { name, value } = e.target;

    // Clear the relevant state variables
    setSyType('');
    setSubjectList([]);
    setLessonList([]);
    setTopicList([]);
    setSubtopicList([]);
    setQuestionList([]);

    // Update the exam data, clearing related fields
    setExamCreateData((prevData) => ({
      ...prevData,
      [name]: value,
      syllabus_structure_id: '',
      syllabus_structure_type: '',
      subject_id: '',
      lesson_id: '',
      topic_id: '',
      subtopic_id: '',
      subjectName: "",
      lessonName: "",
      topicName: "",
      subtopicName: ""
    }));

    // Fetch the syllabus list for the selected class
    getSyllabusList(value);

    // Clear the error for the specific field if it's valid
    if (value.trim() !== '') {
      setErrors(prevErrors => prevErrors.filter(error => error.path[0] !== name));
    }
  };

  const getSyllabusList = (id) => {
    const apiUrlForSyllabus = `/get-all-syllabus-structure-grade-medium-board-wise?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}&instituteGradeMasterId=${id}`;

    // Make the API call to fetch syllabus data
    if (authorizedAxiosCommon) {
      authorizedAxiosCommon.get(apiUrlForSyllabus)
        .then(response => {
          setSyllabusList(response.data.result);
        })
        .catch(error => {
          setSyllabusList([]);
          const errorMsg = error?.response?.data?.message || 'Something went wrong!';
          console.error('Error fetching data:', errorMsg);
        });
    }
  };

  useEffect(() => {
    const apiUrl = `/get-institute-grade?instituteMasterId=${instituteMasterId}`;
    authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
      .then(response => {
        setClassList(response.data.result)
      })
      .catch(error => {
        const errorMsg = error?.response?.data?.message || 'Something went wrong!';
        console.error('Error fetching data:', errorMsg);
      });
  }, [])

  useEffect(() => {
    const fetchQuestions = async () => {
      if (!examCreateData.lesson_id) return; // Exit if lesson_id is empty

      setLoading(true); // Start loading

      let apiUrl = '';
      switch (syType) {
        case 'B':
          apiUrl = `/get-section-question-bank?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}`;
          if (examCreateData.syllabus_structure_id) apiUrl += `&sectionSyllabusStructureMasterId=${examCreateData.syllabus_structure_id}`;
          if (examCreateData.subject_id) apiUrl += `&instituteSubjectMasterId=${examCreateData.subject_id}`;
          if (examCreateData.lesson_id) apiUrl += `&sectionLessonMasterId=${examCreateData.lesson_id}`;
          if (examCreateData.topic_id) apiUrl += `&sectionTopicMasterId=${examCreateData.topic_id}`;
          if (examCreateData.subtopic_id) apiUrl += `&sectionSubTopicMasterId=${examCreateData.subtopic_id}`;
          break;

        case 'I':
          apiUrl = `/get-institute-question-bank?instituteMasterId=${instituteMasterId}`;
          if (examCreateData.syllabus_structure_id) apiUrl += `&instituteSyllabusStructureMasterId=${examCreateData.syllabus_structure_id}`;
          if (examCreateData.subject_id) apiUrl += `&instituteSubjectMasterId=${examCreateData.subject_id}`;
          if (examCreateData.lesson_id) apiUrl += `&instituteLessonMasterId=${examCreateData.lesson_id}`;
          if (examCreateData.topic_id) apiUrl += `&instituteTopicMasterId=${examCreateData.topic_id}`;
          if (examCreateData.subtopic_id) apiUrl += `&instituteSubTopicMasterId=${examCreateData.subtopic_id}`;
          break;

        case 'A':
          apiUrl = `/get-question-bank?`;
          if (examCreateData.syllabus_structure_id) apiUrl += `syllabusStructureMasterId=${examCreateData.syllabus_structure_id}`;
          if (examCreateData.subject_id) apiUrl += `&subjectMasterId=${examCreateData.subject_id}`;
          if (examCreateData.lesson_id) apiUrl += `&lessonMasterId=${examCreateData.lesson_id}`;
          if (examCreateData.topic_id) apiUrl += `&topicMasterId=${examCreateData.topic_id}`;
          if (examCreateData.subtopic_id) apiUrl += `&subTopicMasterId=${examCreateData.subtopic_id}`;
          break;

        default:
          console.error('Invalid syType');
          setLoading(false); // End loading
          return;
      }

      apiUrl = apiUrl.replace(/&$/, ''); // Remove trailing '&' if present
      const axiosInstances = {
        I: authorizedAxiosInstitute,
        A: authorizedAxios,
        B: authorizedAxiosSection
      };

      try {
        const axiosInstance = axiosInstances[syType];
        if (!axiosInstance) throw new Error('Invalid Axios instance');

        const response = await axiosInstance.get(apiUrl);
        // setQuestionList(response.data.data);
        setErrorQuestions(validateCreateExamQuestionData(response.data.data, true, setQuestionList));
      } catch (error) {
        setQuestionList([]);
        const errorMsg = error?.response?.data?.message || 'Something went wrong!';
        console.error('Error fetching data:', errorMsg);
      } finally {
        setLoading(false); // End loading
      }
    };

    fetchQuestions();
  }, [examCreateData.lesson_id, examCreateData.topic_id, examCreateData.subtopic_id]);

  const handleSyllabusChange = (e) => {
    const { name, value } = e.target;

    // Clear the related state variables on syllabus change
    setLessonList([]);
    setTopicList([]);
    setSubtopicList([]);
    setQuestionList([]);

    // Extract syllabus structure id and type from the value
    let id = value.slice(0, -1);  // Extract all but the last character
    let type = value.slice(-1);    // Extract the last character (type)

    setSyType(type);  // Set the syllabus type

    // Update exam data, resetting all relevant fields
    setExamCreateData((prevData) => ({
      ...prevData,
      [name]: id,
      syllabus_structure_type: type,
      subject_id: '',
      lesson_id: '',
      topic_id: '',
      subtopic_id: '',
      subjectName: "",
      lessonName: "",
      topicName: "",
      subtopicName: ""
    }));

    // Define API URLs based on syllabus type
    const apiUrls = {
      I: `get-institute-syllabus-structure-Wise-institute-subjects?id=${id}`,
      A: `/syllabus-structure-wise-subjects?id=${id}`,
      B: `/get-section-syllabus-structure-Wise-section-subjects?id=${id}`
    };

    const axiosInstances = {
      I: authorizedAxiosInstitute,
      A: authorizedAxios,
      B: authorizedAxiosSection
    };

    // Fetch subject list based on syllabus type
    const apiUrl = apiUrls[type];
    const axiosInstance = axiosInstances[type];

    if (axiosInstance && apiUrl) {
      axiosInstance.get(apiUrl)
        .then(response => {
          setSubjectList(response.data.result);
        })
        .catch(error => {
          setSubjectList([]);
          const errorMsg = error?.response?.data?.message || 'Something went wrong!';
          console.error('Error fetching data:', errorMsg);
        });
    }

    // Clear errors for the specific field if it's valid
    if (id.trim() !== '') {
      setErrors(prevErrors => prevErrors.filter(error => error.path[0] !== name));
    }
  };

  const handleSubjectChange = (e) => {
    const { name, value } = e.target;
    const selectedOption = e.target.options[e.target.selectedIndex];
    const selectedSubjectName = selectedOption.getAttribute('data-subject-name');

    // Clear the topic, subtopic, and questions lists when subject changes
    setTopicList([]);
    setSubtopicList([]);
    setQuestionList([]);

    // Update exam data, resetting lesson, topic, and subtopic details
    setExamCreateData((prevData) => ({
      ...prevData,
      [name]: value,
      subjectName: selectedSubjectName,
      lesson_id: '',
      topic_id: '',
      subtopic_id: '',
      lessonName: "",
      topicName: "",
      subtopicName: ""
    }));

    // Clear the error for the specific field if the value is not empty
    if (value.trim() !== '') {
      setErrors(prevErrors => prevErrors.filter(error => error.path[0] !== name));
    }

    // Define API URLs and axios instances based on syType
    const apiUrls = {
      B: `/get-section-subject-wise-section-lesson?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}&sectionSyllabusStructureMasterId=${examCreateData.syllabus_structure_id}&instituteSubjectMasterId=${value}`,
      I: `get-institute-subject-wise-institute-lesson?instituteMasterId=${instituteMasterId}&instituteSyllabusStructureMasterId=${examCreateData.syllabus_structure_id}&instituteSubjectMasterId=${value}`,
      A: `/subject-wise-lesson?syllabusStructureMasterId=${examCreateData.syllabus_structure_id}&subjectMasterId=${value}`
    };

    const axiosInstances = {
      B: authorizedAxiosSection,
      I: authorizedAxiosInstitute,
      A: authorizedAxios
    };

    const apiUrl = apiUrls[syType];
    const axiosInstance = axiosInstances[syType];

    // Fetch data from the respective API if the instance and URL exist
    if (axiosInstance && apiUrl) {
      axiosInstance.get(apiUrl)
        .then(response => {
          setLessonList(response.data.result);
        })
        .catch(error => {
          setLessonList([]);
          const errorMsg = error?.response?.data?.message || 'Something went wrong!';
          console.error('Error fetching data:', errorMsg);
        });
    }
  };

  const handleLessonChange = (e) => {
    const { name, value } = e.target;
    const selectedOption = e.target.options[e.target.selectedIndex];
    const selectedLessonName = selectedOption.getAttribute('data-lesson-name');

    // Clear subtopic list and reset related fields in the state
    setSubtopicList([]);
    setExamCreateData((prevData) => ({
      ...prevData,
      [name]: value,
      lessonName: selectedLessonName,
      topic_id: '',
      subtopic_id: '',
      topicName: "",
      subtopicName: ""
    }));

    // Clear the error for the specific field if the value is not empty
    if (value.trim() !== '') {
      setErrors(prevErrors => prevErrors.filter(error => error.path[0] !== 'lesson_id'));
    }

    // Define API URLs and axios instances based on syType
    const apiUrls = {
      I: `/get-institute-lesson-wise-institute-sub-topic?id=${value}`,
      A: `/lesson-wise-topic?id=${value}`,
      B: `/get-section-lesson-wise-section-sub-topic?id=${value}`
    };

    const axiosInstances = {
      I: authorizedAxiosInstitute,
      A: authorizedAxios,
      B: authorizedAxiosSection
    };

    const apiUrl = apiUrls[syType];
    const axiosInstance = axiosInstances[syType];

    // Fetch data from the respective API if the instance and URL exist
    if (axiosInstance && apiUrl) {
      axiosInstance.get(apiUrl)
        .then(response => {
          setTopicList(response.data.result);
        })
        .catch(error => {
          setTopicList([]);
          const errorMsg = error?.response?.data?.message || 'Something went wrong!';
          console.error('Error fetching data:', errorMsg);
        });
    }
  };

  const handleTopicChange = (e) => {
    const { name, value } = e.target;
    const selectedOption = e.target.options[e.target.selectedIndex];
    const selectedTopicName = selectedOption.getAttribute('data-topic-name');

    // Update exam data state
    setExamCreateData((prevData) => ({
      ...prevData,
      [name]: value,
      topicName: selectedTopicName,
      subtopic_id: '',
      subtopicName: ""
    }));

    // Clear the error for the specific field if the value is not empty
    if (value.trim() !== '') {
      setErrors(prevErrors => prevErrors.filter(error => error.path[0] !== 'topic_id'));
    }

    // Define API URLs and axios instances based on syllabus type
    const apiUrls = {
      I: `/get-institute-sub-topic-master?instituteMasterId=${instituteMasterId}&instituteSyllabusStructureMasterId=${examCreateData.syllabus_structure_id}&instituteSubjectMasterId=${examCreateData.subject_id}&instituteLessonMasterId=${examCreateData.lesson_id}&instituteTopicMasterId=${value}`,
      A: `/get-sub-topic-master-list?syllabusStructureId=${examCreateData.syllabus_structure_id}&subjectMasterId=${examCreateData.subject_id}&lessonId=${examCreateData.lesson_id}&topicId=${value}`,
      B: `/get-section-sub-topic-master?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}&sectionSyllabusStructureMasterId=${examCreateData.syllabus_structure_id}&instituteSubjectMasterId=${examCreateData.subject_id}&sectionLessonMasterId=${examCreateData.lesson_id}&sectionTopicMasterId=${value}`
    };

    const axiosInstances = {
      I: authorizedAxiosInstitute,
      A: authorizedAxios,
      B: authorizedAxiosSection
    };

    const apiUrl = apiUrls[syType];
    const axiosInstance = axiosInstances[syType];

    // Fetch data from the respective API if the instance and URL exist
    if (axiosInstance && apiUrl) {
      axiosInstance.get(apiUrl)
        .then(response => {
          setSubtopicList(response.data.result);
        })
        .catch(error => {
          setSubtopicList([]);
          const errorMsg = error?.response?.data?.message || 'Something went wrong!';
          console.error('Error fetching data:', errorMsg);
        });
    }
  };

  const handleQuestionUpdate = (questionsArray, setExamData, addedQuestions, setAddedQuestions) => {
    setExamData(prevState => {
      const newQuestionIds = [...prevState.questions];
      let updatedAddedQuestions = [...addedQuestions];

      questionsArray.forEach(({ subject_id, lesson_id, topic_id, subtopic_id, questionId, question }) => {
        const existingIndex = newQuestionIds.findIndex(
          item => item.subject_id === subject_id && item.lesson_id === lesson_id && item.topic_id === topic_id && item.subtopic_id === subtopic_id
        );

        if (existingIndex !== -1) {
          const existingItem = newQuestionIds[existingIndex];
          const questionIndex = existingItem.question_ids.indexOf(questionId);

          if (questionIndex !== -1) {
            // Question ID is already present, remove it
            const updatedQuestionIds = existingItem.question_ids.filter(id => id !== questionId);
            updatedAddedQuestions = updatedAddedQuestions.filter(q => q.id !== questionId);

            if (updatedQuestionIds.length === 0) {
              // If no question IDs remain, remove the entire object
              newQuestionIds.splice(existingIndex, 1);
            } else {
              // Otherwise, update the object with the remaining question IDs
              newQuestionIds[existingIndex] = { ...existingItem, question_ids: updatedQuestionIds };
            }
          } else {
            // Question ID is not present, add it
            newQuestionIds[existingIndex] = { ...existingItem, question_ids: [...existingItem.question_ids, questionId] };
            updatedAddedQuestions.push(question); // Add the question to addedQuestions
          }
        } else {
          // Object with subject_id, lesson_id, topic_id, and subtopic_id doesn't exist, add a new one
          newQuestionIds.push({
            subject_id,
            lesson_id,
            topic_id,
            subtopic_id,
            question_ids: [questionId]
          });
          updatedAddedQuestions.push(question); // Add the question to addedQuestions
        }
      });
      // Update setAddedQuestions state
      setAddedQuestions(updatedAddedQuestions);

      return { ...prevState, questions: newQuestionIds };
    });
  };

  const handleAddRemoveSingleQuestion = async (question, examData, setExamData, addedQuestions, setAddedQuestions) => {
    if (!isQuestionSelected(question, addedQuestions)) {
      try {
        if (examType === true) {
          await textBookExamAddQuestion.parseAsync(examData);
          setErrors([]);
        } else {
          await competitiveExamExamAddQuestion.parseAsync(examData);
          setErrorsCompetitiveExam([]);
        }

        handleQuestionUpdate([{
          subject_id: examData.subject_id,
          lesson_id: examData.lesson_id,
          topic_id: examData.topic_id,
          subtopic_id: examData.subtopic_id,
          questionId: question.id,
          question: {
            ...question,
            subjectName: examData.subjectName,
            lessonName: examData.lessonName,
            topicName: examData.topicName,
            subtopicName: examData.subtopicName
          }
        }], setExamData, addedQuestions, setAddedQuestions)
      } catch (error) {
        if (error instanceof ZodError) {
          setErrors(error.errors);
        }
      }
    } else {
      handleQuestionUpdate([{
        subject_id: examData.subject_id,
        lesson_id: examData.lesson_id,
        topic_id: examData.topic_id,
        subtopic_id: examData.subtopic_id,
        questionId: question.id,
        question: {
          ...question,
          subjectName: examData.subjectName,
          lessonName: examData.lessonName,
          topicName: examData.topicName,
          subtopicName: examData.subtopicName
        }
      }], setExamData, addedQuestions, setAddedQuestions)
    }
  }

  const handleSelectAllClick = async (questions, examData, setExamData, addedQuestions, setAddedQuestions) => {
    const formattedQuestions = questions.map((question) => ({
      subject_id: examData.subject_id,
      lesson_id: examData.lesson_id,
      topic_id: examData.topic_id,
      subtopic_id: examData.subtopic_id,
      questionId: question.id,
      question: {
        ...question,
        subjectName: examData.subjectName,
        lessonName: examData.lessonName,
        topicName: examData.topicName,
        subtopicName: examData.subtopicName
      }
    }));

    // Check if all questions are already present
    const allPresent = formattedQuestions.every(({ subject_id, lesson_id, topic_id, subtopic_id, questionId }) => {
      const existingItem = examData.questions.find(
        (item) =>
          item.subject_id === subject_id &&
          item.lesson_id === lesson_id &&
          item.topic_id === topic_id &&
          item.subtopic_id === subtopic_id
      );

      return existingItem && existingItem.question_ids.includes(questionId);
    });

    if (allPresent) {
      // If all are present, remove them
      handleQuestionUpdate(formattedQuestions, setExamData, addedQuestions, setAddedQuestions);
    } else {
      try {
        if (examType === true) {
          await textBookExamAddQuestion.parseAsync(examData);
          setErrors([]);
        } else {
          await competitiveExamExamAddQuestion.parseAsync(examData);
          setErrorsCompetitiveExam([]);
        }


        // If at least one is missing, add only the missing ones
        const missingQuestions = formattedQuestions.filter(({ subject_id, lesson_id, topic_id, subtopic_id, questionId }) => {
          const existingItem = examData.questions.find(
            (item) =>
              item.subject_id === subject_id &&
              item.lesson_id === lesson_id &&
              item.topic_id === topic_id &&
              item.subtopic_id === subtopic_id
          );

          return !(existingItem && existingItem.question_ids.includes(questionId));
        });

        handleQuestionUpdate(missingQuestions, setExamData, addedQuestions, setAddedQuestions);
      } catch (error) {
        if (error instanceof ZodError) {
          setErrors(error.errors);
        }
      }
    }
  };

  // The areAllQuestionsSelected function should return true if all questions are present, otherwise false
  const areAllQuestionsSelected = (questions, addedQuestions) => {
    // If either array is empty, return false
    if (questions.length === 0 || addedQuestions.length === 0) {
      return false;
    }

    // Create a Set of q_id from the addedQuestions array for quick lookup
    const addedQuestionIdsSet = new Set(addedQuestions.map(addedQ => addedQ.id));

    // Check if every q_id in questions exists in the addedQuestions Set
    return questions.every(question => addedQuestionIdsSet.has(question.id));
  };

  const isQuestionSelected = (question, addedQuestions) => {
    return addedQuestions.some(addedQuestion => addedQuestion.id === question.id);
  };

  const handleSelectAllClickTextBookQuestion = () => {
    setExamCreateData((prevData) => {
      return {
        ...prevData,
        questions: []
      }
    });
    setAddedTextBookQuestions([]);
    // setShowAddedTextBookQuestion(false);
  }

  const handleQuestionErrors = (errorQuestionIds, questionList) => {
    const matchedQuestionIndices = errorQuestionIds
      .map(id => {
        const index = questionList.findIndex(question => question.id === id);
        return index !== -1 ? (index + 1).toString() : null;
      })
      .filter(index => index !== null)
      .join(', ');

    const message = `Errors found in questions at indices: ${matchedQuestionIndices}`;
    Swal.fire({ text: message });
  };

  const removeQuestion = (idToRemove, setExamData, setAddedQustions) => {
    try {
      setExamData(prevData => ({
        ...prevData,
        questions: prevData.questions
          .map(question => ({
            ...question,
            question_ids: question.question_ids.filter(id => id !== idToRemove)
          }))
          .filter(question => question.question_ids.length > 0)
      }));

      setAddedQustions(prevAddedQuestions =>
        prevAddedQuestions.filter(question => question.id !== idToRemove)
      );

      return true; // Return true if everything executes successfully
    } catch (error) {
      console.error('Error in removing question:', error);
      return false; // Return false if there's an error
    }
  };

  const deleteQuestion = (id, setExamData, setAddedQuetions) => {
    let confirmed = window.confirm('Are you sure? you want to delete this record.');
    if (confirmed) {
      const isDeleted = removeQuestion(id, setExamData, setAddedQuetions);
      isDeleted ? Swal.fire({ text: "Question deleted successfully" }) : Swal.fire({ text: "Something went wrong!" });
    }
  }

  const createExam = async () => {
    try {
      if (examCreateData.questions.length === 0) {
        await textBookExamCreateSingleSubjectBlankQuestionFormValidation.parseAsync(examCreateData);
      } else {
        if (isMulti === "Y") {
          await textBookExamCreateMultipleSubjectFormValidation.parseAsync(examCreateData);
        } else {
          await textBookExamCreateSingleSubjectFormValidation.parseAsync(examCreateData);
        }
      }

      setErrors([]);
      setLoading(true);

      setErrors([]);
      setLoading(true);
      const questionIds = validateCreateExamQuestionData(addedTextBookQuestions, false);
      if (questionIds.errorCount > 0) {
        handleQuestionErrors(questionIds.errorquestionIds, questionList);
        setLoading(false);
        return;
      }

      const apiUrl = `/exams-v2`;
      const { subject_id, lesson_id, topic_id, subtopic_id, subjectName, lessonName, topicName, subtopicName, ...rest } = examCreateData;

      const data = {
        ...rest,
        exam_type: "M",
        isMulti
      };
      const response = await authorizedAxiosSection.post(apiUrl, data);

      setExamCreateData(initialExamPatternState);
      setSyllabusList([]);
      setSubjectList([]);
      setLessonList([]);
      setTopicList([]);
      setSubtopicList([]);
      setAddedTextBookQuestions([]);
      setShowAddedTextBookQuestion(false);
      setIsMulti("N");
      setErrors([]);
      setSyType();
      setQuestionList([]);

      Swal.fire({ text: response.data.message });
    } catch (error) {
      if (error instanceof ZodError) {
        setErrors(error.errors);
      } else {
        const errorMsg = error?.response?.data?.message || 'Something went wrong!';
        Swal.fire({ text: errorMsg });
      }
    } finally {
      setLoading(false);
    }
  };




  // From Here Competitive Exam
  const handleInputChangeCompetitiveExam = (e) => {
    const { name, value } = e.target;

    if (name === "subtopic_id") {
      const selectedOption = e.target.options[e.target.selectedIndex];
      const selectedSubtopicName = selectedOption.getAttribute('data-subtopic-name');
      setExamCreateDataCompetitiveExam((prevData) => {
        return {
          ...prevData,
          [name]: value,
          subtopicName: selectedSubtopicName
        }
      })
    } else {
      setExamCreateDataCompetitiveExam((prevData) => {
        return {
          ...prevData,
          [name]: value
        }
      })
    }


    // Clear the error for the specific field being edited
    if (value.trim() !== '') {
      setErrorsCompetitiveExam(prevErrors => prevErrors.filter(error => error.path[0] !== name));
    }
  }

  useEffect(() => {
    setExamCreateDataCompetitiveExam((prevData) => {
      return {
        ...prevData,
        questions: []
      }
    })
    setAddedCompetitiveQuestions([]);
  }, [isMultiCompetitive])

  const handleClassChangeCompetitiveExam = (e) => {
    setSyTypeCompetitiveExam(null);
    setCompetitiveExamBookList([]);
    setSubjectListCompetitiveExam([]);
    setLessonListCompetitiveExam([]);
    setTopicListCompetitiveExam([]);
    setSubtopicListCompetitiveExam([]);
    setQuestionListCompetitiveExam([])

    const { name, value } = e.target;
    setExamCreateDataCompetitiveExam((prevData) => {
      return {
        ...prevData,
        [name]: value,
        competitive_exam_id: '',
        competitive_exam_type: '',
        book_id: '',
        subject_id: '',
        lesson_id: '',
        topic_id: '',
        subtopic_id: '',
      }
    })

    getCompetitiveExamNameList(value)

    // Clear the error for the specific field being edited
    if (value.trim() !== '') {
      setErrorsCompetitiveExam(prevErrors => prevErrors.filter(error => error.path[0] !== name));
    }
  }

  const getCompetitiveExamNameList = (id) => {
    const apiUrl = `/get-institute-grade-wise-competitive-exam-name?instituteMasterId=${instituteMasterId}&instituteGradeMasterId=${id}`;
    authorizedAxiosCommon && authorizedAxiosCommon.get(apiUrl)
      .then(response => {
        setCompetitiveExamNameList(response.data.result)
      })
      .catch(error => {
        setCompetitiveExamNameList([]);
        const errorMsg = error?.response?.data?.message || 'Something went wrong!';
        console.error('Error fetching data:', errorMsg);
      });
  }

  const handleCompetitiveExamNameChange = (e) => {
    const { name, value } = e.target; // Destructuring to get 'name' and 'value'

    // Clear existing lists
    setSubjectListCompetitiveExam([]);
    setLessonListCompetitiveExam([]);
    setTopicListCompetitiveExam([]);
    setSubtopicListCompetitiveExam([]);
    setQuestionListCompetitiveExam([]);

    // Extract ID and type from the value
    const id = value.slice(0, -1); // Get everything except the last character
    const type = value.slice(-1);  // Get the last character
    setSyTypeCompetitiveExam(type);

    // Update competitive exam form data
    setExamCreateDataCompetitiveExam((prevData) => ({
      ...prevData,
      [name]: id, // Use destructured 'name' here
      competitive_exam_type: type,
      book_id: '',
      subject_id: '',
      lesson_id: '',
      topic_id: '',
      subtopic_id: ''
    }));

    // Clear error if value is not empty
    if (id.trim() !== '') {
      setErrorsCompetitiveExam(prevErrors =>
        prevErrors.filter(error => error.path[0] !== name) // Use 'name' from destructuring
      );
    }

    // Define API URLs and instances
    const apiUrls = {
      A: `/get-competitive-exam-book-master?competitiveExamNameMasterId=${id}`,
      I: `/get-institute-competitive-exam-book-master?instituteCompetitiveExamNameMasterId=${id}`
    };

    const axiosInstances = {
      A: authorizedAxios,
      I: authorizedAxiosInstitute
    };

    const apiUrl = apiUrls[type];
    const axiosInstance = axiosInstances[type];

    // Fetch data if Axios instance exists
    if (axiosInstance && apiUrl) {
      axiosInstance.get(apiUrl)
        .then(response => {
          setCompetitiveExamBookList(response.data.data);
        })
        .catch(error => {
          setCompetitiveExamBookList([]);
          const errorMsg = error?.response?.data?.message || 'Something went wrong!';
          console.error('Error fetching data:', errorMsg);
        });
    }
  };

  const handleCompetitiveExamBookChange = (e) => {
    // Clear competitive exam lists for cascading data
    setLessonListCompetitiveExam([]);
    setTopicListCompetitiveExam([]);
    setSubtopicListCompetitiveExam([]);
    setQuestionListCompetitiveExam([]);

    // Destructure the name and value from the event
    const { name, value } = e.target;

    // Update the competitive exam data, resetting relevant fields
    setExamCreateDataCompetitiveExam((prevData) => ({
      ...prevData,
      [name]: value,
      subject_id: '',
      lesson_id: '',
      topic_id: '',
      subtopic_id: ''
    }));

    // Clear the error for the specific field if it's not empty
    if (value.trim() !== '') {
      setErrorsCompetitiveExam(prevErrors =>
        prevErrors.filter(error => error.path[0] !== name)
      );
    }

    // Define the API URL and Axios instance based on the competitive exam type
    const apiUrls = {
      I: `/get-institute-competitive-exam-book-wise-subject?instituteCompetitiveExamBookMasterId=${value}`,
      A: `/get-competitive-exam-book-wise-subject?competitiveExamBookMasterId=${value}`
    };

    const axiosInstances = {
      I: authorizedAxiosInstitute,
      A: authorizedAxios
    };

    const apiUrl = apiUrls[syTypeCompetitiveExam];
    const axiosInstance = axiosInstances[syTypeCompetitiveExam];

    // Fetch subject list based on the book ID
    if (axiosInstance && apiUrl) {
      axiosInstance.get(apiUrl)
        .then(response => {
          setSubjectListCompetitiveExam(response.data.result);
        })
        .catch(error => {
          setSubjectListCompetitiveExam([]); // Clear subject list on error
          const errorMsg = error?.response?.data?.message || 'Something went wrong!';
          console.error('Error fetching data:', errorMsg);
        });
    }
  };

  const handleComepetitiveExamSubjectChange = (e) => {
    const { name, value } = e.target;
    const selectedOption = e.target.options[e.target.selectedIndex];
    const selectedSubjectName = selectedOption.getAttribute('data-subject-name');

    // Clear lists for cascading data
    setTopicListCompetitiveExam([]);
    setSubtopicListCompetitiveExam([]);
    setQuestionListCompetitiveExam([]);

    // Update the exam data with the selected subject and reset other fields
    setExamCreateDataCompetitiveExam((prevData) => ({
      ...prevData,
      [name]: value,
      subjectName: selectedSubjectName,
      lesson_id: '',
      topic_id: '',
      subtopic_id: '',
      lessonName: "",
      topicName: "",
      subtopicName: ""
    }));

    // Clear any errors related to this field if a valid value is selected
    if (value.trim() !== '') {
      setErrorsCompetitiveExam(prevErrors =>
        prevErrors.filter(error => error.path[0] !== name)
      );
    }

    // Define API URLs based on the competitive exam type
    const apiUrls = {
      I: `/get-institute-competitive-lesson-master?instituteMasterId=${instituteMasterId}&instituteCompetitiveExamBookMasterId=${examCreateDataCompetitiveExam.book_id}&instituteSubjectMasterId=${value}`,
      A: `/get-competitive-lesson?competitiveExamBookMasterId=${examCreateDataCompetitiveExam.book_id}&subjectMasterId=${value}`
    };

    const axiosInstances = {
      I: authorizedAxiosInstitute,
      A: authorizedAxios
    };

    const apiUrl = apiUrls[syTypeCompetitiveExam];
    const axiosInstance = axiosInstances[syTypeCompetitiveExam];

    // Fetch lesson list based on the selected subject
    if (axiosInstance && apiUrl) {
      axiosInstance.get(apiUrl)
        .then(response => {
          setLessonListCompetitiveExam(response.data.result);
        })
        .catch(error => {
          setLessonListCompetitiveExam([]); // Clear the lesson list on error
          const errorMsg = error?.response?.data?.message || 'Something went wrong!';
          console.error('Error fetching data:', errorMsg);
        });
    }
  };

  const handleCompetitiveExamLessonChange = (e) => {
    const { name, value } = e.target;
    const selectedOption = e.target.options[e.target.selectedIndex];
    const selectedLessonName = selectedOption.getAttribute('data-lesson-name');

    setSubtopicListCompetitiveExam([]);
    setExamCreateDataCompetitiveExam((prevData) => ({
      ...prevData,
      [name]: value,
      lessonName: selectedLessonName,
      topic_id: '',
      subtopic_id: '',
      topicName: "",
      subtopicName: ""
    }));

    // Clear any errors related to this field if a valid value is selected
    if (value.trim() !== '') {
      setErrorsCompetitiveExam(prevErrors =>
        prevErrors.filter(error => error.path[0] !== name)
      );
    }

    // Define the API URLs based on the competitive exam type
    const apiUrls = {
      I: `/get-institute-competitive-topic-master?instituteMasterId=${instituteMasterId}&instituteCompetitiveLessonMasterId=${value}`,
      A: `/get-competitive-topic?competitiveLessonMasterId=${value}`
    };

    const axiosInstances = {
      I: authorizedAxiosInstitute,
      A: authorizedAxios
    };

    const apiUrl = apiUrls[syTypeCompetitiveExam];
    const axiosInstance = axiosInstances[syTypeCompetitiveExam];

    // Fetch the topic list based on the selected lesson
    if (axiosInstance && apiUrl) {
      axiosInstance.get(apiUrl)
        .then(response => {
          setTopicListCompetitiveExam(response.data.result); // Update topic list
        })
        .catch(error => {
          setTopicListCompetitiveExam([]); // Clear topic list on error
          const errorMsg = error?.response?.data?.message || 'Something went wrong!';
          console.error('Error fetching data:', errorMsg);
        });
    }
  };

  const handleCompetitiveExamTopicChange = (e) => {
    const { name, value } = e.target;
    const selectedOption = e.target.options[e.target.selectedIndex];
    const selectedTopicName = selectedOption.getAttribute('data-topic-name');

    // Update the exam data with the selected topic and reset the subtopic field
    setExamCreateDataCompetitiveExam((prevData) => ({
      ...prevData,
      [name]: value,
      topicName: selectedTopicName,
      subtopic_id: '',
      subtopicName: ""
    }));

    // Clear any errors related to this field if a valid value is selected
    if (value.trim() !== '') {
      setErrorsCompetitiveExam(prevErrors =>
        prevErrors.filter(error => error.path[0] !== name)
      );
    }

    // Define the API URLs for institute and competitive exam types
    const apiUrls = {
      I: `/get-institute-competitive-sub-topic-master?instituteMasterId=${instituteMasterId}&instituteCompetitiveExamNameMasterId=${examCreateDataCompetitiveExam.competitive_exam_id}&instituteCompetitiveExamBookMasterId=${examCreateDataCompetitiveExam.book_id}&instituteCompetitiveLessonMasterId=${examCreateDataCompetitiveExam.lesson_id}&instituteCompetitiveTopicMasterId=${value}`,
      A: `/get-competitive-sub-topic?competitiveExamNameMasterId=${examCreateDataCompetitiveExam.competitive_exam_id}&competitiveExamBookMasterId=${examCreateDataCompetitiveExam.book_id}&competitiveLessonMasterId=${examCreateDataCompetitiveExam.lesson_id}&competitiveTopicMasterId=${value}`
    };

    // Choose the correct Axios instance based on the competitive exam type
    const axiosInstances = {
      I: authorizedAxiosInstitute,
      A: authorizedAxios
    };

    const apiUrl = apiUrls[syTypeCompetitiveExam];
    const axiosInstance = axiosInstances[syTypeCompetitiveExam];

    // Fetch the subtopic list based on the selected topic
    if (axiosInstance && apiUrl) {
      axiosInstance.get(apiUrl)
        .then(response => {
          setSubtopicListCompetitiveExam(response.data.result); // Update subtopic list
        })
        .catch(error => {
          setSubtopicListCompetitiveExam([]); // Clear subtopic list on error
          console.error('Error fetching data:', error); // Log error
        });
    }
  };

  useEffect(() => {
    const fetchQuestions = async () => {
      // Exit if lesson_id is empty
      if (!examCreateDataCompetitiveExam.lesson_id) return;

      setLoading(true); // Start loading

      let apiUrl = '';

      try {
        // Construct API URL based on the competitive exam type
        switch (syTypeCompetitiveExam) {
          case 'I':
            apiUrl = `/get-institute-competitive-question-bank?instituteMasterId=${instituteMasterId}`;
            if (examCreateDataCompetitiveExam.competitive_exam_id) apiUrl += `&instituteCompetitiveExamNameMasterId=${examCreateDataCompetitiveExam.competitive_exam_id}`;
            if (examCreateDataCompetitiveExam.book_id) apiUrl += `&instituteCompetitiveExamBookMasterId=${examCreateDataCompetitiveExam.book_id}`;
            if (examCreateDataCompetitiveExam.lesson_id) apiUrl += `&instituteCompetitiveLessonMasterId=${examCreateDataCompetitiveExam.lesson_id}`;
            if (examCreateDataCompetitiveExam.topic_id) apiUrl += `&instituteCompetitiveTopicMasterId=${examCreateDataCompetitiveExam.topic_id}`;
            if (examCreateDataCompetitiveExam.subtopic_id) apiUrl += `&instituteCompetitiveSubTopicMasterId=${examCreateDataCompetitiveExam.subtopic_id}`;
            if (examCreateDataCompetitiveExam.subject_id) apiUrl += `&instituteSubjectMasterId=${examCreateDataCompetitiveExam.subject_id}`;
            break;

          case 'A':
            apiUrl = `/get-competitive-question-bank?`;
            if (examCreateDataCompetitiveExam.competitive_exam_id) apiUrl += `&competitiveExamNameMasterId=${examCreateDataCompetitiveExam.competitive_exam_id}`;
            if (examCreateDataCompetitiveExam.book_id) apiUrl += `&competitiveExamBookMasterId=${examCreateDataCompetitiveExam.book_id}`;
            if (examCreateDataCompetitiveExam.lesson_id) apiUrl += `&competitiveLessonMasterId=${examCreateDataCompetitiveExam.lesson_id}`;
            if (examCreateDataCompetitiveExam.topic_id) apiUrl += `&competitiveTopicMasterId=${examCreateDataCompetitiveExam.topic_id}`;
            if (examCreateDataCompetitiveExam.subtopic_id) apiUrl += `&competitiveSubTopicMasterId=${examCreateDataCompetitiveExam.subtopic_id}`;
            if (examCreateDataCompetitiveExam.subject_id) apiUrl += `&subjectMasterId=${examCreateDataCompetitiveExam.subject_id}`;
            break;

          default:
            console.error('Invalid syTypeCompetitiveExam');
            setLoading(false); // End loading
            return;
        }

        // Remove trailing '&' if present
        apiUrl = apiUrl.replace(/&$/, '');

        // Choose the correct Axios instance based on the competitive exam type
        const axiosInstances = {
          I: authorizedAxiosInstitute,
          A: authorizedAxios
        };

        const axiosInstance = axiosInstances[syTypeCompetitiveExam];
        if (!axiosInstance) throw new Error('Invalid Axios instance');

        // Fetch questions
        const response = await axiosInstance.get(apiUrl);
        // setQuestionListCompetitiveExam(response.data.data);
        setErrorQuestionsCompetitiveExam(validateCreateExamQuestionData(response.data.data, true, setQuestionListCompetitiveExam));

      } catch (error) {
        setQuestionListCompetitiveExam([]);
        const errorMsg = error?.response?.data?.message || 'Something went wrong!';
        console.error('Error fetching data:', errorMsg);
      } finally {
        setLoading(false); // End loading
      }
    };

    fetchQuestions();
  }, [examCreateDataCompetitiveExam.lesson_id, examCreateDataCompetitiveExam.topic_id, examCreateDataCompetitiveExam.subtopic_id]); // Add relevant dependencies

  const createExamCompetitiveExam = async () => {
    try {
      if (examCreateDataCompetitiveExam.questions.length === 0) {
        await competitiveExamCreateSingleSubjectBlankQuestionFormValidation.parseAsync(examCreateDataCompetitiveExam);
      } else {
        if (isMultiCompetitive === "Y") {
          await competitiveExamCreateMultipleSubjectFormValidation.parseAsync(examCreateDataCompetitiveExam);
        } else {
          await competitiveExamCreateSingleSubjectFormValidation.parseAsync(examCreateDataCompetitiveExam);
        }
      }

      setErrorsCompetitiveExam([]);
      setLoading(true);
      const questionIds = validateCreateExamQuestionData(addedCompetitiveQuestions, false);
      if (questionIds.errorCount > 0) {
        handleQuestionErrors(questionIds.errorquestionIds, questionListCompetitiveExam);
        setLoading(false);
        return;
      }

      const apiUrl = `/competitive-exam-v2`;
      const { subject_id, lesson_id, topic_id, subtopic_id, subjectName, lessonName, topicName, subtopicName, ...rest } = examCreateDataCompetitiveExam;
      const data = {
        ...rest,
        exam_type: "M",
        isMulti: isMultiCompetitive
      };

      const response = await authorizedAxiosSection.post(apiUrl, data);

      setExamCreateDataCompetitiveExam(initialCompetitiveExamPatterState);
      setCompetitiveExamNameList([]);
      setSubjectListCompetitiveExam([]);
      setLessonListCompetitiveExam([]);
      setTopicListCompetitiveExam([]);
      setSubtopicListCompetitiveExam([]);
      setAddedCompetitiveQuestions([]);
      setShowAddedCompetitiveQuestion(false);
      setIsMultiCompetitive("N");
      setErrorsCompetitiveExam([]);
      setSyTypeCompetitiveExam(null);
      setQuestionListCompetitiveExam([]);

      Swal.fire({ text: response.data.message });

    } catch (error) {
      if (error instanceof ZodError) {
        setErrorsCompetitiveExam(error.errors);
      } else {
        const errorMsg = error?.response?.data?.message || 'Something went wrong!';
        Swal.fire({ text: errorMsg });
      }
    } finally {
      setLoading(false);
    }
  };

  const handleInputResetCompetitiveExam = () => {
    setSyTypeCompetitiveExam();
    setExamCreateDataCompetitiveExam(initialCompetitiveExamPatterState);
    setQuestionListCompetitiveExam([]);
    setCompetitiveExamNameList([]);
    setCompetitiveExamBookList([]);
    setSubjectListCompetitiveExam([]);
    setLessonListCompetitiveExam([]);
    setTopicListCompetitiveExam([]);
    setSubtopicListCompetitiveExam([]);
    setAddedCompetitiveQuestions([]);
    setShowAddedCompetitiveQuestion(false);
    setIsMultiCompetitive("N");
    setErrorsCompetitiveExam([]);
  }

  const handleInputReset = () => {
    setExamCreateData(initialExamPatternState);
    setSyType();
    setQuestionList([]);
    setSyllabusList([]);
    setSubjectList([]);
    setLessonList([]);
    setTopicList([]);
    setSubtopicList([]);
    setAddedTextBookQuestions([]);
    setShowAddedTextBookQuestion(false);
    setIsMulti("N");
    setErrors([]);
  }

  return (
    <>
      <Loader loading={loading} />
      <div className="wrapper d-flex flex-column min-vh-100 bg-light">
        <Header />
        <div className="container-fluid">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb my-0 ms-2">
              <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/section-dashboard')}>
                <span>Dashboard</span>
              </li>
              <li className="breadcrumb-item active"><span>Exam Create</span></li>
            </ol>
          </nav>
        </div>
        <div className="container-lg">
          <div className="row">
            <div className="card border-info mx-auto mt-3">
              <div className="card-content collpase show">
                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                  <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-file-circle-check"></i> Exam Create</b></h4>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-12">

                      <div className="row">
                        <div className="col-md-6 view_content_radio_btn">
                          <label for="isMulti" className="col-form-label"><span style={{ color: "red" }}>*</span>Choose Subject Type :</label>
                          <label>
                            <input type="radio" name="isMulti" value={true} checked={examType ? isMulti === "N" : isMultiCompetitive === "N"} onChange={() => { examType ? setIsMulti("N") : setIsMultiCompetitive("N") }} /> &nbsp;Single Subject
                          </label>
                          <label>
                            <input type="radio" name="isMulti" value={false} checked={examType ? isMulti === "Y" : isMultiCompetitive === "Y"} onChange={() => { examType ? setIsMulti("Y") : setIsMultiCompetitive("Y") }} /> &nbsp;Multiple Subject
                          </label>
                        </div>
                        <div className="col-md-3">
                          <button className={`${examType ? 'active' : ''} btn btn-light btn-width`} onClick={() => setExamType(true)}>Text Book Exam</button>
                        </div>
                        <div className="col-md-3">
                          <button className={`${examType ? '' : 'active'} btn btn-light btn-width`} onClick={() => setExamType(false)}>Competitive Exam</button>
                        </div>
                      </div>

                      {examType === true && <div className="row">
                        <div className="col-md-6">
                          <label for="examName" className="col-form-label"><span style={{ color: "red" }}>*</span>Exam Name :</label>
                          <input type="text" className="form-control" id={`examName`} name='exam_name' onChange={(e) => handleInputChange(e)} value={examCreateData.exam_name} />
                          <ErrorMessage errors={errors} field="exam_name" />
                        </div>

                        <div className="col-md-6">
                          <label for="description" className="col-form-label"><span style={{ color: "red" }}>*</span>Description :</label>
                          <input type="text" className="form-control" id={`description`} name='description' onChange={(e) => handleInputChange(e)} value={examCreateData.description} />
                          <ErrorMessage errors={errors} field="description" />
                        </div>

                        <div className="col-md-6">
                          <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Class :</label>
                          <select class="form-select" aria-label="Default select example" name='class_id' onChange={handleClassChange} disabled={examCreateData.class_id.length !== 0} value={examCreateData.class_id}>
                            <option selected value={''} disabled>Select Class</option>
                            {
                              classList?.map((syllabus) => {
                                return <option value={syllabus.id}>{syllabus.gradeName}</option>
                              })
                            }
                          </select>
                          <ErrorMessage errors={errors} field="class_id" />
                        </div>

                        <div className="col-md-6">
                          <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Syllabus Structure :</label>
                          <select required class="form-select" aria-label="Default select example" name='syllabus_structure_id' onChange={handleSyllabusChange} disabled={examCreateData.syllabus_structure_id.length !== 0 && examCreateData.syllabus_structure_type.length !== 0} value={examCreateData.syllabus_structure_id + syType}>
                            <option selected value={''} >Select Syllabus</option>
                            {
                              syllabusList?.map((syllabus) => {
                                return <option style={{ color: syllabus.type == "I" ? "blue" : syllabus.type == "B" ? "red" : '' }} value={syllabus.id + syllabus.type}>{syllabus?.syllabusStructureName}</option>
                              })
                            }
                          </select>
                          <ErrorMessage errors={errors} field="syllabus_structure_id" />
                        </div>

                        {syType == "B" && <>
                          <div className="col-md-6">
                            <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Subject :</label>
                            <select required class="form-select" aria-label="Default select example" name='subject_id' onChange={handleSubjectChange} disabled={isMulti === "N" ? examCreateData.subject_id.length !== 0 : false} value={examCreateData?.subject_id}>
                              <option selected value={''} disabled>Select Subject</option>
                              {
                                subjectList?.map((syllabus) => {
                                  const { id, subjectName } = syllabus?.instituteSubjectMasterDetails;
                                  return <option key={id} value={id} data-subject-name={subjectName}>{subjectName}</option>
                                })
                              }
                            </select>
                            <ErrorMessage errors={errors} field="subject_id" />
                          </div>

                          <div className="col-md-6">
                            <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Lesson :</label>
                            <select required class="form-select" aria-label="Default select example" name='lesson_id' onChange={handleLessonChange} value={examCreateData.lesson_id}>
                              <option selected value={''} disabled>Select Lesson</option>
                              {
                                lessonList?.map((lesson) => {
                                  const { id, sectionLessonName } = lesson; // Extract id and sectionLessonName
                                  return <option key={id} value={id} data-lesson-name={sectionLessonName}>{sectionLessonName}</option>
                                })
                              }
                            </select>
                            <ErrorMessage errors={errors} field="lesson_id" />
                          </div>

                          <div className="col-md-6">
                            <label for="inputPassword" className="col-form-label">Select Topic :</label>
                            <select required class="form-select" aria-label="Default select example" name='topic_id' onChange={handleTopicChange} value={examCreateData.topic_id}>
                              <option selected value={''} disabled>Select Topic</option>
                              {
                                topicList?.map((topic) => {
                                  const { id, sectionTopicName } = topic; // Extract id and sectionTopicName
                                  return <option key={id} value={id} data-topic-name={sectionTopicName}>{sectionTopicName}</option>
                                })
                              }
                            </select>
                            <ErrorMessage errors={errors} field="topic_id" />
                          </div>

                          <div className="col-md-6">
                            <label for="inputPassword" className="col-form-label">Select Sub Topic :</label>
                            <select required class="form-select" aria-label="Default select example" name='subtopic_id' onChange={handleInputChange} value={examCreateData.subtopic_id}>
                              <option selected value={''} disabled>Select Sub Topic</option>
                              {
                                subtopicList?.map((subtopic) => {
                                  const { id, sectionSubTopicName } = subtopic;
                                  return <option key={id} value={id} data-subtopic-name={sectionSubTopicName}>{sectionSubTopicName}</option>
                                })
                              }
                            </select>
                            <ErrorMessage errors={errors} field="subtopic_id" />
                          </div>
                        </>}

                        {syType == "I" && <>
                          <div className="col-md-6">
                            <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Subject :</label>
                            <select required class="form-select" aria-label="Default select example" name='subject_id' onChange={handleSubjectChange} disabled={isMulti === "N" ? examCreateData.subject_id.length !== 0 : false} value={examCreateData?.subject_id}>
                              <option selected value={''} disabled>Select Subject</option>
                              {
                                subjectList?.map((syllabus) => {
                                  const { id, subjectName } = syllabus?.instituteSubjectMasterDetails;
                                  return <option key={id} value={id} data-subject-name={subjectName}>{subjectName}</option>
                                })
                              }
                            </select>
                            <ErrorMessage errors={errors} field="subject_id" />
                          </div>
                          <div className="col-md-6">
                            <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Lesson :</label>
                            <select required class="form-select" aria-label="Default select example" name='lesson_id' onChange={handleLessonChange} value={examCreateData.lesson_id}>
                              <option selected value={''} disabled>Select Lesson</option>
                              {
                                lessonList?.map((lesson) => {
                                  const { id, instituteLessonName } = lesson;
                                  return <option key={id} value={id} data-lesson-name={instituteLessonName}>{instituteLessonName}</option>
                                })
                              }
                            </select>
                            <ErrorMessage errors={errors} field="lesson_id" />
                          </div>
                          <div className="col-md-6">
                            <label for="inputPassword" className="col-form-label">Select Topic :</label>
                            <select required class="form-select" aria-label="Default select example" name='topic_id' onChange={handleTopicChange} value={examCreateData.topic_id}>
                              <option selected value={''} disabled>Select Topic</option>
                              {
                                topicList?.map((topic) => {
                                  const { id, instituteTopicName } = topic;
                                  return <option key={id} value={id} data-topic-name={instituteTopicName}>{instituteTopicName}</option>
                                })
                              }
                            </select>
                            <ErrorMessage errors={errors} field="topic_id" />
                          </div>

                          <div className="col-md-6">
                            <label for="inputPassword" className="col-form-label">Select Sub Topic :</label>
                            <select required class="form-select" aria-label="Default select example" name='subtopic_id' onChange={handleInputChange} value={examCreateData.subtopic_id}>
                              <option selected value={''} disabled>Select Sub Topic</option>
                              {
                                subtopicList?.map((subtopic) => {
                                  const { id, instituteSubTopicName } = subtopic;
                                  return <option key={id} value={id} data-subtopic-name={instituteSubTopicName}>{instituteSubTopicName}</option>
                                })
                              }
                            </select>
                            <ErrorMessage errors={errors} field="subtopic_id" />
                          </div>
                        </>}

                        {syType == "A" && <>
                          <div className="col-md-6">
                            <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Subject :</label>
                            <select required class="form-select" aria-label="Default select example" name='subject_id' onChange={handleSubjectChange} disabled={isMulti === "N" ? examCreateData.subject_id.length !== 0 : false} value={examCreateData?.subject_id}>
                              <option selected value={''}>Select Subject</option>
                              {
                                subjectList?.map((syllabus) => {
                                  const { id, subjectName } = syllabus?.subjectMasterDetails;
                                  return <option key={id} value={id} data-subject-name={subjectName}>{subjectName}</option>
                                })
                              }
                            </select>
                            <ErrorMessage errors={errors} field="subject_id" />
                          </div>
                          <div className="col-md-6">
                            <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Lesson :</label>
                            <select required class="form-select" aria-label="Default select example" name='lesson_id' onChange={handleLessonChange} value={examCreateData.lesson_id}>
                              <option selected value={''} disabled>Select Lesson</option>
                              {
                                lessonList?.map((lesson) => {
                                  const { id, lessonName } = lesson;
                                  return <option key={id} value={id} data-lesson-name={lessonName}>{lessonName}</option>
                                })
                              }
                            </select>
                            <ErrorMessage errors={errors} field="lesson_id" />
                          </div>
                          <div className="col-md-6">
                            <label for="inputPassword" className="col-form-label">Select Topic :</label>
                            <select required class="form-select" aria-label="Default select example" name='topic_id' onChange={handleTopicChange} value={examCreateData.topic_id}>
                              <option selected value={''} disabled>Select Topic</option>
                              {
                                topicList?.map((topic) => {
                                  const { id, topicName } = topic;
                                  return <option key={id} value={id} data-topic-name={topicName}>{topicName}</option>
                                })
                              }
                            </select>
                            <ErrorMessage errors={errors} field="topic_id" />
                          </div>

                          <div className="col-md-6">
                            <label for="inputPassword" className="col-form-label">Select Sub Topic :</label>
                            <select required class="form-select" aria-label="Default select example" name='subtopic_id' onChange={handleInputChange} value={examCreateData.subtopic_id}>
                              <option selected value={''} disabled>Select Sub Topic</option>
                              {
                                subtopicList?.map((subtopic) => {
                                  const { id, subTopicName } = subtopic;
                                  return <option key={id} value={id} data-subtopic-name={subTopicName}>{subTopicName}</option>
                                })
                              }
                            </select>
                            <ErrorMessage errors={errors} field="subtopic_id" />
                          </div>
                        </>}

                        <div className="btn-sticky col-md-12 mt-3" style={{ display: 'flex', justifyContent: 'space-between', gap: '10px' }}>
                          <button className="btn btn-primary" style={{ flex: '1', padding: '10px', marginRight: '10px' }} type="button"
                            disabled={examCreateData.questions.length === 0 ? true : showAddedTextBookQuestion === true && showAddedTextBookQuestion !== 0 ? true : false}
                            onClick={() => setShowAddedTextBookQuestion(true)}
                          >
                            Added Question
                          </button>
                          <button className="btn btn-secondary" style={{ flex: '1', padding: '10px', marginRight: '10px' }} type="button"
                            disabled={showAddedTextBookQuestion === false}
                            onClick={() => setShowAddedTextBookQuestion(false)}
                          >
                            Return
                          </button>
                          <button className="btn btn-success" style={{ flex: '1', padding: '10px', marginRight: '10px' }} type="button" onClick={createExam}>Save</button>
                          <button className="btn btn-danger" style={{ flex: '1', padding: '10px' }} type="button" onClick={handleInputReset}>Reset</button>
                        </div>

                        {examCreateData.syllabus_structure_id !== "" && showAddedTextBookQuestion === false &&
                          <div className="d-grid gap-2 mt-2">
                            <div class="tab-content rounded-bottom custom_table custom_table_width">
                              <div class="tab-pane p-3 active prefilter" role="tabpanel" id="prefilter-1000">
                                <div>
                                  {errorQuestions.errorCount > 0 && (
                                    <div className="alert alert-danger" role="alert">
                                      {errorQuestions.errorCount === 1 ?
                                        `There is ${errorQuestions.errorCount} invalid or empty question` :
                                        `There are ${errorQuestions.errorCount} invalid or empty questions`
                                      }
                                    </div>
                                  )}
                                </div>
                                {questionList.length > 0 && <ErrorMessage errors={errors} field="questions" />}
                                <table class="table">
                                  <thead>
                                    <tr>
                                      {questionList?.length > 0 && <th scope="col">
                                        <input
                                          type='checkbox'
                                          checked={areAllQuestionsSelected(questionList, addedTextBookQuestions)}
                                          onClick={() => handleSelectAllClick(questionList, examCreateData, setExamCreateData, addedTextBookQuestions, setAddedTextBookQuestions)}
                                        /> All
                                      </th>}
                                      <th scope="col" className='sl_no'>Sr. No.</th>
                                      <th scope='col'>Q_Level</th>
                                      <th scope='col'>Q_Type</th>
                                      <th scope='col'>Question</th>
                                      <th scope="col">Option_a</th>
                                      <th scope="col">Option_b </th>
                                      <th scope="col">Option_c</th>
                                      <th scope="col">Option_d</th>
                                      <th scope='col'>Answer</th>
                                      <th scope='col'>Solution</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {
                                      questionList?.length > 0 ?
                                        questionList?.map((question, index) => {
                                          <QuestionFilter key={index} question={question}></QuestionFilter>
                                          const rowClass = isErrorCreateExamQuestion(errorQuestions, question) ? 'error-row' : '';
                                          return (
                                            <tr key={index} className={rowClass}>
                                              <td>
                                                <input type='checkbox' checked={isQuestionSelected(question, addedTextBookQuestions)}
                                                  onChange={() => (
                                                    handleAddRemoveSingleQuestion(question, examCreateData, setExamCreateData, addedTextBookQuestions, setAddedTextBookQuestions)
                                                  )}
                                                />
                                              </td>
                                              <th scope="row" className='sl_no'>{index + 1}</th>
                                              <td>{question.q_level}</td>
                                              <td>{question.q_type}</td>
                                              <ViewImageAndText inputString={question.question} onViewImage={onViewImage} />
                                              <ViewImageAndText inputString={question.option_a} onViewImage={onViewImage} />
                                              <ViewImageAndText inputString={question.option_b} onViewImage={onViewImage} />
                                              <ViewImageAndText inputString={question.option_c} onViewImage={onViewImage} />
                                              <ViewImageAndText inputString={question.option_d} onViewImage={onViewImage} />
                                              <td>{question.ans}</td>
                                              <td>
                                                <button className="btn btn-primary view_icon mt-1" type="button" onClick={() => {
                                                  setVisible(!visible)
                                                  setModalData(question.sol)

                                                  // setVisibleImage(!visibleImage);
                                                  // setModalImageSrc(question.sol);
                                                }}><i class="fa fa-eye"></i></button>
                                              </td>
                                            </tr>
                                          )
                                        })
                                        :
                                        (<tr>
                                          <th colspan={"100%"} style={{ textAlign: 'center' }}>No Questions Available</th>
                                        </tr>)
                                    }
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        }

                        {showAddedTextBookQuestion === true &&
                          <div className="d-grid gap-2 mt-2">
                            <div class="tab-content rounded-bottom custom_table custom_table_width">
                              <div class="tab-pane p-3 active prefilter" role="tabpanel" id="prefilter-1000">
                                {/* {errorQuestions.errorCount > 0 && (
                                  <div className="alert alert-danger" role="alert">
                                    {errorQuestions.errorCount === 1 ?
                                      `There is ${errorQuestions.errorCount} invalid or empty question` :
                                      `There are ${errorQuestions.errorCount} invalid or empty questions`
                                    }
                                  </div>
                                )} */}
                                <table class="table">
                                  <thead>
                                    <tr>
                                      {/* {addedTextBookQuestions?.length > 0 && <th scope="col">
                                          <input
                                            type='checkbox'
                                            checked={addedTextBookQuestions.length > 0}
                                            onClick={() => handleSelectAllClickTextBookQuestion()}
                                          /> All
                                        </th>} */}
                                      <th scope="col" className='sl_no'>Sr. No.</th>
                                      <th scope='col'>Subject</th>
                                      <th scope='col'>Lesson</th>
                                      <th scope='col'>Topic</th>
                                      <th scope='col'>SubTopic</th>
                                      <th scope="col">Question</th>
                                      <th scope='col'>Solution</th>
                                      <th scope='col'>Action</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {
                                      addedTextBookQuestions?.length > 0 ?
                                        addedTextBookQuestions?.map((question, index) => {
                                          const rowClass = isErrorCreateExamQuestion(errorQuestions, question) ? 'error-row' : '';
                                          return (
                                            <tr key={index} className={rowClass}>
                                              <th scope="row" className='sl_no'>{index + 1}</th>
                                              <td>{question.subjectName}</td>
                                              <td>{question.lessonName}</td>
                                              <td>{question.topicName}</td>
                                              <td>{question.subtopicName}</td>
                                              <ViewImageAndText inputString={question.question} onViewImage={onViewImage} />
                                              <ViewImageAndText inputString={question.sol} onViewImage={onViewImage} />
                                              <td>
                                                <button className="btn btn-outline-danger delete_icon" type="button" onClick={() => deleteQuestion(question.id, setExamCreateData, setAddedTextBookQuestions)}> <i class="fa-light fa-trash-can"></i></button>
                                              </td>
                                            </tr>
                                          )
                                        })
                                        :
                                        (<tr>
                                          <th colspan={"100%"} style={{ textAlign: 'center' }}>No Questions Available</th>
                                        </tr>)
                                    }
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        }
                      </div>}

                      {examType === false && <div className="row">
                        <div className="col-md-6">
                          <label for="examName" className="col-form-label"><span style={{ color: "red" }}>*</span>Exam Name </label>
                          <input type="text" className="form-control" id={`examName`} name='exam_name' onChange={handleInputChangeCompetitiveExam} value={examCreateDataCompetitiveExam.exam_name} />
                          <ErrorMessage errors={errorsCompetitiveExam} field="exam_name" />
                        </div>

                        <div className="col-md-6">
                          <label for="description" className="col-form-label"><span style={{ color: "red" }}>*</span>Description  </label>
                          <input type="text" className="form-control" id={`description`} name='description' onChange={handleInputChangeCompetitiveExam} value={examCreateDataCompetitiveExam.description} />
                          <ErrorMessage errors={errorsCompetitiveExam} field="description" />
                        </div>

                        <div className="col-md-6">
                          <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Class :</label>
                          <select class="form-select" aria-label="Default select example" name='class_id' onChange={handleClassChangeCompetitiveExam} disabled={examCreateDataCompetitiveExam.class_id.length !== 0} value={examCreateDataCompetitiveExam.class_id}>
                            <option selected value={''} disabled>Select Class</option>
                            {
                              classList?.map((syllabus) => {
                                return <option value={syllabus.id}>{syllabus.gradeName}</option>
                              })
                            }
                          </select>
                          <ErrorMessage errors={errorsCompetitiveExam} field="class_id" />
                        </div>

                        <div className="col-md-6">
                          <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Competitive Exam :</label>
                          <select required class="form-select" aria-label="Default select example" name='competitive_exam_id' onChange={handleCompetitiveExamNameChange} disabled={examCreateDataCompetitiveExam.competitive_exam_id.length !== 0} value={examCreateDataCompetitiveExam.competitive_exam_id + syTypeCompetitiveExam}>
                            <option selected value={''} >Select Competitive Exam</option>
                            {
                              competitiveExamNameList?.map((competitiveExamName) => {
                                return <option style={{ color: competitiveExamName.type == "I" ? "blue" : competitiveExamName.type == "B" ? "red" : '' }} value={competitiveExamName.id + competitiveExamName.type}>{competitiveExamName?.examName}</option>
                              })
                            }
                          </select>
                          <ErrorMessage errors={errorsCompetitiveExam} field="competitive_exam_id" />
                        </div>

                        <div className="col-md-6">
                          <label for="book_id" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Book :</label>
                          <select required class="form-select" aria-label="Default select example" name='book_id' onChange={handleCompetitiveExamBookChange} disabled={examCreateDataCompetitiveExam.book_id.length !== 0} value={examCreateDataCompetitiveExam.book_id}>
                            <option selected value={''} disabled>Select Book</option>
                            {
                              competitiveExamBookList?.map((syllabus) => {
                                return <option value={syllabus.id}>{syllabus.bookName}</option>
                              })
                            }
                          </select>
                          <ErrorMessage errors={errorsCompetitiveExam} field="book_id" />
                        </div>

                        {syTypeCompetitiveExam == "I" && <>
                          <div className="col-md-6">
                            <label for="subject_id" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Subject :</label>
                            <select required class="form-select" aria-label="Default select example" name='subject_id' onChange={handleComepetitiveExamSubjectChange} disabled={isMultiCompetitive === "N" ? examCreateDataCompetitiveExam.subject_id.length !== 0 : false} value={examCreateDataCompetitiveExam?.subject_id}>
                              <option selected value={''} disabled>Select Subject</option>
                              {
                                subjectListCompetitiveExam?.map((subject) => {
                                  const { id, subjectName } = subject?.instituteSubjectMasterDetails;
                                  // return <option value={syllabus?.instituteSubjectMasterDetails?.id}>{syllabus?.instituteSubjectMasterDetails?.subjectName}</option>
                                  return <option key={id} value={id} data-subject-name={subjectName}>{subjectName}</option>
                                })
                              }
                            </select>
                            <ErrorMessage errors={errorsCompetitiveExam} field="subject_id" />
                          </div>
                          <div className="col-md-6">
                            <label for="lesson_id" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Lesson :</label>
                            <select required class="form-select" aria-label="Default select example" name='lesson_id' onChange={handleCompetitiveExamLessonChange} value={examCreateDataCompetitiveExam.lesson_id}>
                              <option selected value={''} disabled>Select Lesson</option>
                              {
                                lessonListCompetitiveExam?.map((lesson) => {
                                  const { id, competitiveLessonName } = lesson;
                                  // return <option value={lesson?.id}>{lesson?.competitiveLessonName}</option>
                                  return <option key={id} value={id} data-lesson-name={competitiveLessonName}>{competitiveLessonName}</option>
                                })
                              }
                            </select>
                            <ErrorMessage errors={errorsCompetitiveExam} field="lesson_id" />
                          </div>
                          <div className="col-md-6">
                            <label for="topic_id" className="col-form-label">Select Topic :</label>
                            <select required class="form-select" aria-label="Default select example" name='topic_id' onChange={handleCompetitiveExamTopicChange} value={examCreateDataCompetitiveExam.topic_id}>
                              <option selected value={''} disabled>Select Topic</option>
                              {
                                topicListCompetitiveExam?.map((topic) => {
                                  const { id, competitiveTopicName } = topic;
                                  // return <option value={topic?.id}>{topic?.competitiveTopicName}</option>
                                  return <option key={id} value={id} data-topic-name={competitiveTopicName}>{competitiveTopicName}</option>
                                })
                              }
                            </select>
                            <ErrorMessage errors={errorsCompetitiveExam} field="topic_id" />
                          </div>

                          <div className="col-md-6">
                            <label for="subtopic_id" className="col-form-label">Select Sub Topic :</label>
                            <select required class="form-select" aria-label="Default select example" name='subtopic_id' onChange={handleInputChangeCompetitiveExam} value={examCreateDataCompetitiveExam.subtopic_id}>
                              <option selected value={''} disabled>Select Sub Topic</option>
                              {
                                subtopicListCompetitiveExam?.map((subtopic) => {
                                  const { id, competitiveSubTopicName } = subtopic;
                                  // return <option value={subtopic?.id}>{subtopic?.competitiveSubTopicName}</option>
                                  return <option key={id} value={id} data-subtopic-name={competitiveSubTopicName}>{competitiveSubTopicName}</option>
                                })
                              }
                            </select>
                            <ErrorMessage errors={errorsCompetitiveExam} field="subtopic_id" />
                          </div>
                        </>}

                        {syTypeCompetitiveExam == "A" && <>
                          <div className="col-md-6">
                            <label for="subject_id" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Subject :</label>
                            <select required class="form-select" aria-label="Default select example" name='subject_id' onChange={handleComepetitiveExamSubjectChange} disabled={isMultiCompetitive === "N" ? examCreateDataCompetitiveExam.subject_id.length !== 0 : false} value={examCreateDataCompetitiveExam?.subject_id}>
                              <option selected value={''}>Select Subject</option>
                              {
                                subjectListCompetitiveExam?.map((subject) => {
                                  const { id, subjectName } = subject?.subjectMasterDetails;
                                  // return <option value={syllabus?.subjectMasterDetails?.id}>{syllabus?.subjectMasterDetails?.subjectName}</option>
                                  return <option key={id} value={id} data-subject-name={subjectName}>{subjectName}</option>
                                })
                              }
                            </select>
                            <ErrorMessage errors={errorsCompetitiveExam} field="subject_id" />
                          </div>
                          <div className="col-md-6">
                            <label for="lesson_id" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Lesson :</label>
                            <select required class="form-select" aria-label="Default select example" name='lesson_id' onChange={handleCompetitiveExamLessonChange} value={examCreateDataCompetitiveExam.lesson_id}>
                              <option selected value={''} disabled>Select Lesson</option>
                              {
                                lessonListCompetitiveExam?.map((lesson) => {
                                  const { id, competitiveLessonName } = lesson;
                                  // return <option value={lesson?.id}>{lesson?.competitiveLessonName}</option>
                                  return <option key={id} value={id} data-lesson-name={competitiveLessonName}>{competitiveLessonName}</option>
                                })
                              }
                            </select>
                            <ErrorMessage errors={errorsCompetitiveExam} field="lesson_id" />
                          </div>
                          <div className="col-md-6">
                            <label for="topic_id" className="col-form-label">Select Topic :</label>
                            <select required class="form-select" aria-label="Default select example" name='topic_id' onChange={handleCompetitiveExamTopicChange} value={examCreateDataCompetitiveExam.topic_id}>
                              <option selected value={''} disabled>Select Topic</option>
                              {
                                topicListCompetitiveExam?.map((topic) => {
                                  const { id, competitiveTopicName } = topic;
                                  // return <option value={topic?.id}>{topic?.competitiveTopicName}</option>
                                  return <option key={id} value={id} data-topic-name={competitiveTopicName}>{competitiveTopicName}</option>
                                })
                              }
                            </select>
                            <ErrorMessage errors={errorsCompetitiveExam} field="topic_id" />
                          </div>
                          <div className="col-md-6">
                            <label for="subtopic_id" className="col-form-label">Select Sub Topic :</label>
                            <select required class="form-select" aria-label="Default select example" name='subtopic_id' onChange={handleInputChangeCompetitiveExam} value={examCreateDataCompetitiveExam.subtopic_id}>
                              <option selected value={''} disabled>Select Sub Topic</option>
                              {
                                subtopicListCompetitiveExam?.map((subtopic) => {
                                  const { id, competitiveSubTopicName } = subtopic;
                                  // return <option value={topic?.id}>{topic?.competitiveSubTopicName}</option>
                                  return <option key={id} value={id} data-subtopic-name={competitiveSubTopicName}>{competitiveSubTopicName}</option>
                                })
                              }
                            </select>
                            <ErrorMessage errors={errorsCompetitiveExam} field="subtopic_id" />
                          </div>
                        </>}

                        <div className="btn-sticky col-md-12 mt-3" style={{ display: 'flex', justifyContent: 'space-between', gap: '10px' }}>
                          <button className="btn btn-primary" style={{ flex: '1', padding: '10px', marginRight: '10px' }} type="button"
                            disabled={examCreateDataCompetitiveExam.questions.length === 0 ? true : showAddedCompetitiveQuestion === true && showAddedCompetitiveQuestion !== 0 ? true : false}
                            onClick={() => setShowAddedCompetitiveQuestion(true)}
                          >
                            Added Question
                          </button>
                          <button className="btn btn-secondary" style={{ flex: '1', padding: '10px', marginRight: '10px' }} type="button"
                            disabled={showAddedCompetitiveQuestion === false}
                            onClick={() => setShowAddedCompetitiveQuestion(false)}
                          >
                            Return
                          </button>
                          <button className="btn btn-success" style={{ flex: '1', padding: '10px', marginRight: '10px' }} type="button" onClick={createExamCompetitiveExam}>Save</button>
                          <button className="btn btn-danger" style={{ flex: '1', padding: '10px' }} type="button" onClick={handleInputResetCompetitiveExam}>Reset</button>
                        </div>

                        {examCreateDataCompetitiveExam.competitive_exam_id !== "" && showAddedCompetitiveQuestion === false &&
                          <div className="d-grid gap-2 mt-2">
                            <div class="tab-content rounded-bottom custom_table custom_table_width">
                              <div class="tab-pane p-3 active prefilter" role="tabpanel" id="prefilter-1000">
                                <div>
                                  {errorQuestionsCompetitiveExam.errorCount > 0 && (
                                    <div className="alert alert-danger" role="alert">
                                      {errorQuestionsCompetitiveExam.errorCount === 1 ?
                                        `There is ${errorQuestionsCompetitiveExam.errorCount} invalid or empty question` :
                                        `There are ${errorQuestionsCompetitiveExam.errorCount} invalid or empty questions`
                                      }
                                    </div>
                                  )}
                                </div>
                                {questionListCompetitiveExam.length > 0 && <ErrorMessage errors={errorsCompetitiveExam} field="questions" />}
                                <table class="table">
                                  <thead>
                                    <tr>
                                      {questionListCompetitiveExam?.length > 0 && <th scope="col">
                                        <input
                                          type='checkbox'
                                          checked={areAllQuestionsSelected(questionListCompetitiveExam, addedCompetitiveQuestions)}
                                          onClick={() => handleSelectAllClick(questionListCompetitiveExam, examCreateDataCompetitiveExam, setExamCreateDataCompetitiveExam, addedCompetitiveQuestions, setAddedCompetitiveQuestions)}
                                        /> All
                                      </th>}
                                      <th scope="col" className='sl_no'>Sr. No.</th>
                                      <th scope='col'>Q_Level</th>
                                      <th scope='col'>Q_Type</th>
                                      <th scope='col'>Question</th>
                                      <th scope="col">Option_a</th>
                                      <th scope="col">Option_b </th>
                                      <th scope="col">Option_c</th>
                                      <th scope="col">Option_d</th>
                                      <th scope='col'>Answer</th>
                                      <th scope='col'>Solution</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {
                                      questionListCompetitiveExam?.length > 0 ?
                                        questionListCompetitiveExam?.map((question, index) => {
                                          <QuestionFilter key={index} question={question}></QuestionFilter>
                                          const rowClass = isErrorCreateExamQuestion(errorQuestionsCompetitiveExam, question) ? 'error-row' : '';
                                          return (
                                            <tr key={index} className={rowClass}>
                                              <td>
                                                <input type='checkbox' checked={isQuestionSelected(question, addedCompetitiveQuestions)}
                                                  onChange={() => (
                                                    handleAddRemoveSingleQuestion(question, examCreateDataCompetitiveExam, setExamCreateDataCompetitiveExam, addedCompetitiveQuestions, setAddedCompetitiveQuestions)
                                                  )}
                                                />
                                              </td>
                                              <th scope="row" className='sl_no'>{index + 1}</th>
                                              <td>{question.q_level}</td>
                                              <td>{question.q_type}</td>
                                              <ViewImageAndText inputString={question.question} onViewImage={onViewImage} />
                                              <ViewImageAndText inputString={question.option_a} onViewImage={onViewImage} />
                                              <ViewImageAndText inputString={question.option_b} onViewImage={onViewImage} />
                                              <ViewImageAndText inputString={question.option_c} onViewImage={onViewImage} />
                                              <ViewImageAndText inputString={question.option_d} onViewImage={onViewImage} />
                                              <td>{question.ans}</td>
                                              <td>
                                                <button className="btn btn-primary view_icon mt-1" type="button" onClick={() => {
                                                  setVisible(!visible)
                                                  setModalData(question.sol)
                                                }}><i class="fa fa-eye" ></i></button>
                                              </td>
                                            </tr>
                                          )
                                        })
                                        :
                                        (<tr>
                                          <th colspan={"100%"} style={{ textAlign: 'center' }}>No Questions Available</th>
                                        </tr>)
                                    }
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        }

                        {showAddedCompetitiveQuestion === true &&
                          <div className="d-grid gap-2 mt-2">
                            <div class="tab-content rounded-bottom custom_table custom_table_width">
                              <div class="tab-pane p-3 active prefilter" role="tabpanel" id="prefilter-1000">
                                {/* {errorQuestionsCompetitiveExam.errorCount > 0 && (
                                  <div className="alert alert-danger" role="alert">
                                    {errorQuestionsCompetitiveExam.errorCount === 1 ?
                                      `There is ${errorQuestionsCompetitiveExam.errorCount} invalid or empty question` :
                                      `There are ${errorQuestionsCompetitiveExam.errorCount} invalid or empty questions`
                                    }
                                  </div>
                                )} */}
                                <table class="table">
                                  <thead>
                                    <tr>
                                      {/* {addedTextBookQuestions?.length > 0 && <th scope="col">
                                          <input
                                            type='checkbox'
                                            checked={addedTextBookQuestions.length > 0}
                                            onClick={() => handleSelectAllClickTextBookQuestion()}
                                          /> All
                                        </th>} */}
                                      <th scope="col" className='sl_no'>Sr. No.</th>
                                      <th scope='col'>Subject</th>
                                      <th scope='col'>Lesson</th>
                                      <th scope='col'>Topic</th>
                                      <th scope='col'>SubTopic</th>
                                      <th scope="col">Question</th>
                                      <th scope='col'>Solution</th>
                                      <th scope='col'>Action</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {
                                      addedCompetitiveQuestions?.length > 0 ?
                                        addedCompetitiveQuestions?.map((question, index) => {
                                          const rowClass = isErrorCreateExamQuestion(errorQuestionsCompetitiveExam, question) ? 'error-row' : '';
                                          return (
                                            <tr key={index} className={rowClass}>
                                              <th scope="row" className='sl_no'>{index + 1}</th>
                                              <td>{question.subjectName}</td>
                                              <td>{question.lessonName}</td>
                                              <td>{question.topicName}</td>
                                              <td>{question.subtopicName}</td>
                                              <ViewImageAndText inputString={question.question} onViewImage={onViewImage} />
                                              <ViewImageAndText inputString={question.sol} onViewImage={onViewImage} />
                                              <td>
                                                <button className="btn btn-outline-danger delete_icon" type="button" onClick={() => deleteQuestion(question.id, setExamCreateDataCompetitiveExam, setAddedCompetitiveQuestions)}> <i class="fa-light fa-trash-can"></i></button>
                                              </td>
                                            </tr>
                                          )
                                        })
                                        :
                                        (<tr>
                                          <th colspan={"100%"} style={{ textAlign: 'center' }}>No Questions Available</th>
                                        </tr>)
                                    }
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        }
                      </div>}

                    </div>
                  </div>

                  {visible && <SolutionModal visibleSolution={visible} setVisibleSolution={setVisible} modalData={modalData} />}

                  {visibleImage && <ImageModal visibleImage={visibleImage} setVisibleImage={setVisibleImage} modalImageSrc={modalImageSrc} />}

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
};

export default CreateExam;